<template>
  <div id="contact-info">
    <v-layout
      v-if="store.servicer"
      row
    >
      <v-flex>
        <p class="mb-0 mt-1 text-xs-center grey--text text--darken-1">
          {{ splashFooterQuestions }}
        </p>

        <p
          v-if="isPresent(fullName)"
          class="mb-0 mt-1 text-xs-center grey--text text--darken-1"
        >
          {{ splashFooterContact }} {{ fullName }}
        </p>

        <p
          v-if="isPresent(store.servicer.title)"
          class="mb-0 text-xs-center grey--text text--darken-1"
        >
          {{ store.servicer.title }}
        </p>

        <p
          v-if="isPresent(store.servicer.email)"
          class="mb-0 text-xs-center grey--text text--darken-1"
        >
          {{ store.servicer.email }}
        </p>

        <p
          v-if="isPresent(store.servicer.website)"
          class="mb-0 text-xs-center grey--text text--darken-1"
        >
          {{ store.servicer.website }}
        </p>

        <p
          v-if="isPresent(store.servicer.unformatted_phone)"
          class="mb-0 text-xs-center grey--text text--darken-1"
        >
          {{ splashFooterCell }} {{ store.servicer.unformatted_phone | sn_utilMixin_formatPhone }}
        </p>

        <p
          v-if="isPresent(store.servicer.office_phone)"
          class="text-xs-center grey--text text--darken-1"
        >
          {{ splashFooterWorkPhone }} {{ store.servicer.office_phone }}
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import utilMixin from '../common/utilMixin'

export default {
  name: 'ContactInfo',
  mixins: [utilMixin],
  data () {
    return {
      store: this.$store
    }
  },

  computed: {
    fullName () {
      var names = []
      if (this.isPresent(this.store.servicer.name)) {
        names.push(this.store.servicer.name)
      }
      if (this.isPresent(this.store.servicer.last_name)) {
        names.push(this.store.servicer.last_name)
      }
      return names.join(' ')
    },
    splashFooterQuestions () {
      return this.store.borrowerWebContent?.splashFooterQuestions
    },
    splashFooterContact () {
      return this.store.borrowerWebContent?.splashFooterContact
    },
    splashFooterCell () {
      return this.store.borrowerWebContent?.splashFooterCell
    },
    splashFooterWorkPhone () {
      return this.store.borrowerWebContent?.splashFooterWorkPhone
    }
  },

  methods: {
    isPresent (value) {
      return value && value.trim().length > 0
    }
  }
}
</script>
